// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sorting symbols for table component */

/* From github.com/reactabular/reactabular/blob/master/style.css
   Can't easily be written in JS and parsed to CSS */

/* TODO: replace by a component solution in JS */

.buildrz-table .sort {
  cursor: pointer;
}

.buildrz-table .sort:after {
  display: inline-block;
  position: relative;
  top: -0.1em;
  right: 1em;
}

.buildrz-table .sort-none:after {
  content: '\\21D5';
}

.buildrz-table .sort-asc:after {
  content: '\\25B2';
  font-size: 0.5em;
  top: -1.2em;
  right: 1.7em;
}

.buildrz-table .sort-desc:after {
  content: '\\25BC';
  font-size: 0.5em;
  right: 1.7em;
}

/* React table */

.ReactTable {
  border: 1px solid #e6e6e6;
}

.ReactTable .rt-thead {
  color: hsl(0, 0%, 50%);
  font-size: 1rem;
}

.ReactTable .rt-th {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.ReactTable .rt-thead.-header {
  box-shadow: unset;
  border-top: 1px solid hsl(0, 0%, 70%);
  border-bottom: 1px solid hsl(0, 0%, 70%);
}

.ReactTable .rt-thead.-filters {
  background-color: transparent;
  border-bottom: 1px solid hsl(0, 0%, 90%);
  margin: 2px 0;
}

.ReactTable .rt-thead.-filters input {
  padding: 2px;
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 1px solid hsl(0, 0%, 70%);
}

.ReactTable .rt-thead .rt-resizable-header-content {
  white-space: normal;
  /* overflow-wrap: break-word; */
}

.ReactTable .rt-tfoot {
  box-shadow: unset;
}

.ReactTable .rt-noData {
  position: relative;
  top: 30px;
  background-color: white;
  border-radius: 0 0 8px 8px;
  border-bottom: none;
}

.ReactTable .rt-th,
.ReactTable .rt-td {
  white-space: normal;
  /* overflow-wrap: break-word; */
}

.ReactTable .-pagination {
  padding: 0;
  box-shadow: none;
  border-top: none;
  border-bottom: 1px solid hsl(0, 0%, 70%);
}

.ReactTable .-pagination .-center {
  justify-content: center;
}

.ReactTable .-pagination .-btn {
  border-radius: 0;
  background: transparent;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
  background-color: hsl(0, 0%, 80%);
}

.ReactTable .-pagination .-btn[disabled] {
  opacity: 0;
}

.ReactTable .-pagination .-pageJump input {
  padding: 0;
  margin: 3px;
  border: 1px solid hsl(0, 0%, 90%);
}

a.project-link {
  color: hsl(0, 0%, 10%);
  text-decoration: none;
  font-weight: bold;
}

a.project-link:hover {
  text-decoration: underline;
}

.ReactTable .rt-expander {
  margin: 0;
  padding-right: 10px;
}

.ReactTable .rt-expander-hide .rt-expandable {
  cursor: default;
}

.ReactTable .rt-expander-hide .rt-expander {
  display: none;
}

.projectsTable {
  height: calc(100% - 50px);
  width: 100%;
  border: none;
}

.projectsTable .rt-tr {
  transition: background-color 150ms ease-in-out;
}

.projectsTable .rt-tbody {
  overflow: unset;
}

/** Project Table **/

.projectTable {
  border: 1px solid hsl(0, 0%, 90%);
  border-radius: 8px;
}

.projectTable .rt-th {
  border: none;
  border-bottom: 1px solid hsl(0, 0%, 90%);
  outline: none;
  display: flex;
  justify-content: flex-end;
  text-align: right;
}

.projectTable .rt-thead .rt-th {
  border: none;
  padding: 8px;
  color: hsl(0, 0%, 25%);
}

.projectTable .rt-thead.-header {
  background-color: hsl(0, 0%, 98%);
  border-radius: 8px 8px 0;
  text-transform: none;
  font-size: 1rem;
  border: none;
}

.projectTable .rt-tr.-even {
  background-color: hsl(0, 0%, 98%);
}

.projectTable .rt-tbody .rt-td {
  text-align: right;
  border: none;
  padding: 8px;
}

.projectTable .rt-tbody .rt-tr-group {
  border: none;
}

.projectTable .rt-tbody .rt-tr-group:last-child {
  border: none;
}

.projectTable .-pagination {
  border-bottom: none;
  margin-bottom: 8px;
}

/** Table inside a card block (eg bilan) **/

.blockTable,
.blockTable .rt-thead.-header {
  border-radius: 0;
}

/** Table inside a card block with rounded bottom (eg basias) **/

.blockTableRounded,
.blockTableRounded .rt-thead.-header,
.blockTableRounded .rt-tbody {
  border-radius: 0 0 8px 8px;
}

/** Table display density: compact */

.compact .rt-thead .rt-th,
.compact .rt-tbody .rt-td {
  padding: 4px;
}

/* Left aligned cells in table */

.leftalign .rt-thead .rt-th {
  display: flex;
  justify-content: flex-start;
  margin-left: 8px;
}

.leftalign .rt-tbody .rt-td {
  display: flex;
  margin-left: 8px;
  text-align: left;
}

/** Project Subtable **/
.projectSubTable {
  border: none;
  border-bottom: 1px solid hsl(0, 0%, 90%);
}

/** Report Table **/

.reportTable {
  border: 1px solid hsl(0, 0%, 90%);
  border-radius: 8px;
}

.reportTable .rt-th {
  border: none;
  border-bottom: 1px solid hsl(0, 0%, 90%);
  outline: none;
  display: flex;
  justify-content: flex-end;
  text-align: right;
}

.reportTable .rt-thead .rt-th {
  border: none;
  padding: 15px 10px;
}

.reportTable .rt-thead.-header {
  background-color: hsl(0, 0%, 98%);
  text-transform: none;
  font-size: 1rem;
  border: none;
  border-radius: 8px 8px 0 0;
}

.reportTable .rt-tr.-even {
  background-color: hsl(0, 0%, 98%);
}

.reportTable .rt-tbody .rt-td {
  text-align: right;
  border: none;
  padding: 8px 16px;
}

.reportTable .rt-tbody .rt-tr-group {
  border: none;
}

.reportTable .rt-tbody .rt-tr-group:nth-child(6) .rt-td:first-child,
.reportTable .rt-tbody .rt-tr-group:nth-child(8) .rt-td:first-child,
.reportTable .rt-tbody .rt-tr-group:nth-child(10) .rt-td:first-child {
  font-style: italic;
  padding-left: 60px;
}

.reportTable .rt-tbody .rt-td:first-child {
  text-align: left;
}

.reportTable .rt-tbody .rt-tr-group:last-child {
  border: none;
}

.reportTable .rt-tr.-even:last-child {
  border-radius: 0 0 8px 8px;
}

/** Contact Table **/

.contactTable {
  border: none;
  border-radius: 8px;
}

.contactTable .rt-th {
  display: flex;
  justify-content: flex-end;
}

.contactTable .rt-thead .rt-th {
  border: none;
  padding: 4px;
  color: hsl(0, 0%, 60%);
}

.contactTable .rt-thead.-header {
  background-color: transparent;
  text-transform: none;
  font-size: 0.9rem;
  border: none;
  border-bottom: 1px solid hsl(0, 0%, 90%);
}

.contactTable .rt-tbody .rt-td {
  text-align: left;
  border: none;
  padding: 4px;
  font-size: 1rem;
}

.contactTable .rt-tbody .rt-tr-group {
  border: none;
}

.contactTable .rt-tbody .rt-tr-group:last-child {
  border: none;
}
`, "",{"version":3,"sources":["webpack://./css/table.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;oDACoD;;AAEpD,gDAAgD;;AAEhD;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;;AAEhB;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;;AAEpB;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2CAA2C;;AAE3C;;EAEE,gBAAgB;AAClB;;AAEA,gEAAgE;;AAEhE;;;EAGE,0BAA0B;AAC5B;;AAEA,oCAAoC;;AAEpC;;EAEE,YAAY;AACd;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,mBAAmB;;AAEnB;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Sorting symbols for table component */\n\n/* From github.com/reactabular/reactabular/blob/master/style.css\n   Can't easily be written in JS and parsed to CSS */\n\n/* TODO: replace by a component solution in JS */\n\n.buildrz-table .sort {\n  cursor: pointer;\n}\n\n.buildrz-table .sort:after {\n  display: inline-block;\n  position: relative;\n  top: -0.1em;\n  right: 1em;\n}\n\n.buildrz-table .sort-none:after {\n  content: '\\21D5';\n}\n\n.buildrz-table .sort-asc:after {\n  content: '\\25B2';\n  font-size: 0.5em;\n  top: -1.2em;\n  right: 1.7em;\n}\n\n.buildrz-table .sort-desc:after {\n  content: '\\25BC';\n  font-size: 0.5em;\n  right: 1.7em;\n}\n\n/* React table */\n\n.ReactTable {\n  border: 1px solid #e6e6e6;\n}\n\n.ReactTable .rt-thead {\n  color: hsl(0, 0%, 50%);\n  font-size: 1rem;\n}\n\n.ReactTable .rt-th {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ReactTable .rt-thead.-header {\n  box-shadow: unset;\n  border-top: 1px solid hsl(0, 0%, 70%);\n  border-bottom: 1px solid hsl(0, 0%, 70%);\n}\n\n.ReactTable .rt-thead.-filters {\n  background-color: transparent;\n  border-bottom: 1px solid hsl(0, 0%, 90%);\n  margin: 2px 0;\n}\n\n.ReactTable .rt-thead.-filters input {\n  padding: 2px;\n}\n\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 1px solid hsl(0, 0%, 70%);\n}\n\n.ReactTable .rt-thead .rt-resizable-header-content {\n  white-space: normal;\n  /* overflow-wrap: break-word; */\n}\n\n.ReactTable .rt-tfoot {\n  box-shadow: unset;\n}\n\n.ReactTable .rt-noData {\n  position: relative;\n  top: 30px;\n  background-color: white;\n  border-radius: 0 0 8px 8px;\n  border-bottom: none;\n}\n\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  white-space: normal;\n  /* overflow-wrap: break-word; */\n}\n\n.ReactTable .-pagination {\n  padding: 0;\n  box-shadow: none;\n  border-top: none;\n  border-bottom: 1px solid hsl(0, 0%, 70%);\n}\n\n.ReactTable .-pagination .-center {\n  justify-content: center;\n}\n\n.ReactTable .-pagination .-btn {\n  border-radius: 0;\n  background: transparent;\n}\n\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background-color: hsl(0, 0%, 80%);\n}\n\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0;\n}\n\n.ReactTable .-pagination .-pageJump input {\n  padding: 0;\n  margin: 3px;\n  border: 1px solid hsl(0, 0%, 90%);\n}\n\na.project-link {\n  color: hsl(0, 0%, 10%);\n  text-decoration: none;\n  font-weight: bold;\n}\n\na.project-link:hover {\n  text-decoration: underline;\n}\n\n.ReactTable .rt-expander {\n  margin: 0;\n  padding-right: 10px;\n}\n\n.ReactTable .rt-expander-hide .rt-expandable {\n  cursor: default;\n}\n\n.ReactTable .rt-expander-hide .rt-expander {\n  display: none;\n}\n\n.projectsTable {\n  height: calc(100% - 50px);\n  width: 100%;\n  border: none;\n}\n\n.projectsTable .rt-tr {\n  transition: background-color 150ms ease-in-out;\n}\n\n.projectsTable .rt-tbody {\n  overflow: unset;\n}\n\n/** Project Table **/\n\n.projectTable {\n  border: 1px solid hsl(0, 0%, 90%);\n  border-radius: 8px;\n}\n\n.projectTable .rt-th {\n  border: none;\n  border-bottom: 1px solid hsl(0, 0%, 90%);\n  outline: none;\n  display: flex;\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.projectTable .rt-thead .rt-th {\n  border: none;\n  padding: 8px;\n  color: hsl(0, 0%, 25%);\n}\n\n.projectTable .rt-thead.-header {\n  background-color: hsl(0, 0%, 98%);\n  border-radius: 8px 8px 0;\n  text-transform: none;\n  font-size: 1rem;\n  border: none;\n}\n\n.projectTable .rt-tr.-even {\n  background-color: hsl(0, 0%, 98%);\n}\n\n.projectTable .rt-tbody .rt-td {\n  text-align: right;\n  border: none;\n  padding: 8px;\n}\n\n.projectTable .rt-tbody .rt-tr-group {\n  border: none;\n}\n\n.projectTable .rt-tbody .rt-tr-group:last-child {\n  border: none;\n}\n\n.projectTable .-pagination {\n  border-bottom: none;\n  margin-bottom: 8px;\n}\n\n/** Table inside a card block (eg bilan) **/\n\n.blockTable,\n.blockTable .rt-thead.-header {\n  border-radius: 0;\n}\n\n/** Table inside a card block with rounded bottom (eg basias) **/\n\n.blockTableRounded,\n.blockTableRounded .rt-thead.-header,\n.blockTableRounded .rt-tbody {\n  border-radius: 0 0 8px 8px;\n}\n\n/** Table display density: compact */\n\n.compact .rt-thead .rt-th,\n.compact .rt-tbody .rt-td {\n  padding: 4px;\n}\n\n/* Left aligned cells in table */\n\n.leftalign .rt-thead .rt-th {\n  display: flex;\n  justify-content: flex-start;\n  margin-left: 8px;\n}\n\n.leftalign .rt-tbody .rt-td {\n  display: flex;\n  margin-left: 8px;\n  text-align: left;\n}\n\n/** Project Subtable **/\n.projectSubTable {\n  border: none;\n  border-bottom: 1px solid hsl(0, 0%, 90%);\n}\n\n/** Report Table **/\n\n.reportTable {\n  border: 1px solid hsl(0, 0%, 90%);\n  border-radius: 8px;\n}\n\n.reportTable .rt-th {\n  border: none;\n  border-bottom: 1px solid hsl(0, 0%, 90%);\n  outline: none;\n  display: flex;\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.reportTable .rt-thead .rt-th {\n  border: none;\n  padding: 15px 10px;\n}\n\n.reportTable .rt-thead.-header {\n  background-color: hsl(0, 0%, 98%);\n  text-transform: none;\n  font-size: 1rem;\n  border: none;\n  border-radius: 8px 8px 0 0;\n}\n\n.reportTable .rt-tr.-even {\n  background-color: hsl(0, 0%, 98%);\n}\n\n.reportTable .rt-tbody .rt-td {\n  text-align: right;\n  border: none;\n  padding: 8px 16px;\n}\n\n.reportTable .rt-tbody .rt-tr-group {\n  border: none;\n}\n\n.reportTable .rt-tbody .rt-tr-group:nth-child(6) .rt-td:first-child,\n.reportTable .rt-tbody .rt-tr-group:nth-child(8) .rt-td:first-child,\n.reportTable .rt-tbody .rt-tr-group:nth-child(10) .rt-td:first-child {\n  font-style: italic;\n  padding-left: 60px;\n}\n\n.reportTable .rt-tbody .rt-td:first-child {\n  text-align: left;\n}\n\n.reportTable .rt-tbody .rt-tr-group:last-child {\n  border: none;\n}\n\n.reportTable .rt-tr.-even:last-child {\n  border-radius: 0 0 8px 8px;\n}\n\n/** Contact Table **/\n\n.contactTable {\n  border: none;\n  border-radius: 8px;\n}\n\n.contactTable .rt-th {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.contactTable .rt-thead .rt-th {\n  border: none;\n  padding: 4px;\n  color: hsl(0, 0%, 60%);\n}\n\n.contactTable .rt-thead.-header {\n  background-color: transparent;\n  text-transform: none;\n  font-size: 0.9rem;\n  border: none;\n  border-bottom: 1px solid hsl(0, 0%, 90%);\n}\n\n.contactTable .rt-tbody .rt-td {\n  text-align: left;\n  border: none;\n  padding: 4px;\n  font-size: 1rem;\n}\n\n.contactTable .rt-tbody .rt-tr-group {\n  border: none;\n}\n\n.contactTable .rt-tbody .rt-tr-group:last-child {\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
